import React from "react";

// Utility to join class names
const cn = (...classes) => classes.filter(Boolean).join(" ");

// Domain-specific check

function Checkbox({ checked, onChange }) {
  const boxSize = "w-[16px] h-[16px]";
  const svgSize = "w-[16px] h-[16px]";

  return (
    <label className="relative inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="peer sr-only" // hide the native checkbox
      />

      {/* Custom visual box */}
      <div
        className={cn(
          boxSize,
          "rounded border border-gray-300 transition-colors",
          "peer-checked:bg-blue peer-checked:border-blue"
        )}
      />

      {/* White check icon */}
      <svg
        className={cn(
          "absolute left-0 top-0 hidden text-white peer-checked:block pointer-events-none",
          svgSize
        )}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="20 6 9 17 4 12" />
      </svg>
    </label>
  );
}

export { Checkbox };
